/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function() {
  if(localStorage.last_visit_time != undefined){
    if((Date.now() - localStorage.last_visit_time*1) > 1*24*60*60*1000){
      localStorage.last_visit_time = Date.now();
      localStorage.used_filter = '';
      localStorage.league_picker = '';
      localStorage.team_picker = '';
    }
  }else{
    localStorage.last_visit_time = Date.now();
    localStorage.used_filter = '';
    localStorage.league_picker = '';
    localStorage.team_picker = '';
  }   
  const searchParams = new URLSearchParams(window.location.search);
  var utm_properties = `<input type="hidden" name="properties[_device_width]" value="${window.innerWidth}px">`;  
  if(localStorage.cart_progress == "styleB"){
    utm_properties += `<input type="hidden" name="properties[_free_shipping_bar]" value="styleB">`;
  }else{
    utm_properties += `<input type="hidden" name="properties[_free_shipping_bar]" value="styleA">`;
  }  
  document.querySelectorAll('#facet-filters-form .product-facet__filter-item collapsible-content').forEach((item)=>{
    item.addEventListener('click',function(){
        var option_val = item.previousElementSibling.getAttribute('data-label');
        if(localStorage.used_filter == ''){
            localStorage.used_filter = option_val
        }else if(localStorage.used_filter.indexOf(option_val)<0){            
            localStorage.used_filter =localStorage.used_filter+ ', '+ option_val
        }
        document.querySelectorAll('[name="properties[_used_filters]"]').forEach((i_t)=>{
          i_t.value = localStorage.used_filter;
        })
    })
  })
  if(localStorage.used_filter != ''){
     utm_properties += `<input type="hidden" name="properties[_used_filters]" value="${localStorage.used_filter}">`; 
   }
  
  var clicked_section = '';
  searchParams.forEach((val,key)=>{
    switch(key){
      case "internal_referral":          
        utm_properties += `<input type="hidden" name="properties[_internal_referral]" value="${val}">`;
        break;
      case "utm_source":
        utm_properties += `<input type="hidden" name="properties[_utm_source]" value="${val}">`;          
        break;
      case "utm_medium":
        utm_properties += `<input type="hidden" name="properties[_utm_medium]" value="${val}">`;          
        break;
      case "utm_campaign":
        utm_properties += `<input type="hidden" name="properties[_utm_campaign]" value="${val}">`;          
        break;
      case "utm_term":
        utm_properties += `<input type="hidden" name="properties[_utm_term]" value="${val}">`;          
        break;
      case "utm_content":
        utm_properties += `<input type="hidden" name="properties[_utm_content]" value="${val}">`;          
        break;
      case "section":
        utm_properties += `<input type="hidden" name="properties[_section]" value="${val}">`;          
        break;
      case "section_clicked":
        utm_properties += `<input type="hidden" name="properties[_section_clicked]" value="${val}">`; 
        clicked_section += val+', '; 
        break;
      case "league_picker":
        if(localStorage.league_picker == ''){
            localStorage.league_picker = val
        }else if(localStorage.league_picker){
          let league_list = localStorage.league_picker.split(', ');
          if(!league_list.includes(val)){            
            localStorage.league_picker =localStorage.league_picker+ ', '+ val
          }
        }               
        break;
      case "team_picker":
        if(localStorage.team_picker == ''){
            localStorage.team_picker = val
        }else if(localStorage.team_picker){
          let team_list = localStorage.team_picker.split(', ');
          if(!team_list.includes(val)){            
            localStorage.team_picker =localStorage.team_picker+ ', '+ val
          }
        }                
        break;
    }              
      
  })
  if(localStorage.team_picker){
    utm_properties += `<input type="hidden" name="properties[_used_team_picker]" value="${localStorage.team_picker}">`;  
    document.querySelectorAll('[name="properties[_used_team_picker]"]').forEach((i_t)=>{
      i_t.value = localStorage.team_picker;
    })
  }
  if(localStorage.league_picker){
    utm_properties += `<input type="hidden" name="properties[_used_league_picker]" value="${localStorage.league_picker}">`;   
    document.querySelectorAll('[name="properties[_used_league_picker]"]').forEach((i_t)=>{
      i_t.value = localStorage.league_picker;
    })
  }
  document.querySelectorAll('#main>*').forEach(item=>{
      var section_name = item.querySelector('[data-section-title]')?.getAttribute('data-section-title') || item.getAttribute('id');
      item.querySelectorAll('[href]:not([href^="#"])').forEach(s_item=>{
        if(s_item.getAttribute('href').indexOf('?')>0){
          let temp_href = s_item.getAttribute('href') + '&section_clicked=' + clicked_section +  section_name;
          s_item.setAttribute('href',temp_href);  
        }else{
          let temp_href = s_item.getAttribute('href') + '?section_clicked=' + clicked_section +  section_name;
          s_item.setAttribute('href',temp_href);    
        }
      })
  })
  localStorage.custom_utm_properties = utm_properties;
  document.querySelectorAll('.utm_properties').forEach(item=>{
    item.innerHTML = utm_properties;
  })
  
  document.querySelector('product-facet')?.addEventListener('click',function(event){
    if(event.target.classList.contains('zuo-filter-trigger')){
      let target_label = event.target.getAttribute('data-slot');
      document.querySelectorAll('.product-facet__filter-item>button[aria-expanded="true"]').forEach(t=>{
          t.click();
      })
      document.querySelector('.product-facet__filter-item>button[data-label="'+target_label+'"]').click();
      document.querySelector('.product-facet__meta-bar-item--filter').click();
    }
  })
  
  document.addEventListener('variant:changed', function(event) {
    
    let variant = event.detail.variant; 
    let form = event.target;

   
    let reflexEl = document.querySelector('.reflex');
   
    if(window.product_json == undefined) {
    	let product_jsonEl = document.querySelector('#product_jsonEl');
      if(product_jsonEl) {
        eval(product_jsonEl.innerHTML);
      }
    }
//     console.log(window.product_json);
//     console.log(variant);
    if(reflexEl && window.product_json ) {
      if(window.product_json.vendor.indexOf('PC On Demand') != -1){
        if(variant.inventory_quantity <= 0 && variant.available){
          reflexEl.style.display = 'flex';        
        } else{
          reflexEl.style.display = 'none';        
        }
      }
      if(window.product_json.vendor.indexOf('Manufacturing On Demand') != -1){
        if(variant.inventory_quantity <= 0 && variant.available){
          reflexEl.style.display = 'flex';        
        } else{
          reflexEl.style.display = 'none';        
        }
      }
      if(window.product_json.vendor.indexOf('Applique On Demand') != -1){
        if(variant.inventory_quantity <= 0 && variant.available){
          reflexEl.style.display = 'flex';        
        } else{
          reflexEl.style.display = 'none';        
        }
      }
      if(window.product_json.vendor.indexOf('Weekly Replenishment') != -1){
        if(variant.inventory_quantity <= 0 && variant.available){
          reflexEl.style.display = 'flex';        
        } else{
          reflexEl.style.display = 'none';        
        }
      }
    }
  });

  document.addEventListener('click', function(e){
    var el = e.target;

    if(el.classList.contains('open_custom_menu_link') || el.closest('.open_custom_menu_link')) {
      if(!el.classList.contains('open_custom_menu_link')) {
        el = el.closest('.open_custom_menu_link');
      }
      e.preventDefault();
      let prevActiveLink = el.closest('.linklist').querySelector('.open_custom_menu_link.active');
      if(prevActiveLink) {
        let prevActiveLink_handle = prevActiveLink.getAttribute('data-menu-handle');
        let prevActive_custom_menu_blockEl = document.querySelector('.custom_menu_block[data-menu-handle="'+prevActiveLink_handle+'"]');
        if(prevActive_custom_menu_blockEl) {
          prevActive_custom_menu_blockEl.classList.remove('active');
        }
        prevActiveLink.classList.remove('active');
      }
          
      let menu_handle = el.getAttribute('data-menu-handle');
      let custom_menu_blockEl = document.querySelector('.custom_menu_block[data-menu-handle="'+menu_handle+'"]');
      if(custom_menu_blockEl) {
      	custom_menu_blockEl.classList.add('active');
        el.classList.add('active');
      }
    }
  });
  
  var refer = location.pathname;
  document.querySelectorAll('a[href*="collection"]:not([href^="#"]').forEach(item=>{
      let temp_href = item.getAttribute('href').indexOf('?')>0 ? item.getAttribute('href') + '&internal_referral=' + location.pathname.split('/').slice(-1)[0] : item.getAttribute('href') + '?internal_referral=' + location.pathname.split('/').slice(-1)[0];
      item.setAttribute('href',temp_href);    
  })
  document.querySelectorAll('a[href*="product"]:not([href^="#"])').forEach(item=>{
      let temp_href = item.getAttribute('href').indexOf('?')>0 ? item.getAttribute('href') + '&internal_referral=' + location.pathname.split('/').slice(-1)[0] : item.getAttribute('href') + '?internal_referral=' + location.pathname.split('/').slice(-1)[0];
      item.setAttribute('href',temp_href);  
  })
  document.querySelectorAll('.product-item__quick-add-button').forEach(item=>{
    item.addEventListener('click', function(){
      this.setAttribute('aria-busy',true);
      this.setAttribute('disabled','disabled');
      let option = this.closest('.product-item-quick-add-wraper-zuo').querySelector('button .select__selected-value').innerText;
      this.closest('product-item').querySelector('.product-item_quick-add-js .variant-option[variant-title="'+option+'"]').click();
    })
  })  
  if(document.querySelector('.first-loading')){
    setTimeout(function(){
      document.querySelector('.first-loading .initial-loading')?.remove();
      document.querySelector('.first-loading').classList.remove('first-loading');
    },1000)    
  }

  document.querySelectorAll('body[class*="temp_collection_landing-"] .multi-column__link').forEach(shopBtn => {
    shopBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector('.shopify-section--main-collection-width-zuo-filter');
      const offset = 100; // Adjust this value as needed
      window.scrollTo({
          top: target.offsetTop - offset,
          behavior: 'smooth'
      });
    });
  });
  
});
